export default {"src":"/_next/static/media/fastexercise.770aaf4b.svg","height":200,"width":200,"blurWidth":0,"blurHeight":0};